import { render, staticRenderFns } from "./rzNotice.vue?vue&type=template&id=ab76c810&scoped=true&"
import script from "./rzNotice.vue?vue&type=script&lang=js&"
export * from "./rzNotice.vue?vue&type=script&lang=js&"
import style0 from "./rzNotice.vue?vue&type=style&index=0&id=ab76c810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab76c810",
  null
  
)

export default component.exports